import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IStoreState } from './types';
import { selectSelectedRestaurantId, selectToken } from './auth/selectors';

export const api = createApi({
	reducerPath: 'api',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/api`,
		prepareHeaders: (headers, { getState }) => {
			headers.set('restaurant-id', selectSelectedRestaurantId(<IStoreState>getState()));
			headers.set('Authorization', `Bearer ${selectToken(<IStoreState>getState())}`);
		},
		paramsSerializer: (params) => {
			if (!params) {
				return '';
			}

			const query = new URLSearchParams();

			Object.entries(params).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					// Since URLSearchParams doesn't really support arrays, we need to append every array item separately
					value.forEach((item) => query.append(key, item));
				} else {
					query.append(key, value);
				}
			});

			return decodeURIComponent(query.toString());
		},
	}),
	tagTypes: [],
	endpoints: () => ({}),
});

export const {
	util: { invalidateTags },
} = api;
